import { FC, useEffect } from "react"
import s from './DetailServices.module.scss'
import { useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { fetchByDetailservices } from "../../store/slices/servicesSlice"

const DetailServices:FC =()=>{
    const { id, name } = useParams()
    const dispatch = useAppDispatch()
    const { detail, loading } = useAppSelector(state => state.services)

    useEffect(()=>{
        dispatch(fetchByDetailservices(Number(id)))
    },[])

    return(
        <>
        
        </>
    )
}

export default DetailServices